import React, {useState} from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useDeviceDetect } from 'hooks';

import { DropDownMenu } from '.';
import { AddressCard } from '../sections';

const Wrapper = styled.div`
  position: relative;
  margin-right: 30px;
  &:last-of-type {
    margin-right: 0px;
  }
  width: 100%;
`
const Button = styled.a`
  display: flex;
  width: 100%;
  position: absolute;
  z-index: 10000;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  text-transform: none;
  background-color: ${props => props.theme.colors.gray};
  color: ${props => props.theme.colors.black};
  font-weight: 500;
  border-radius: ${props => props.theme.borderRadius.round};
  outline: none;
  border: 1px solid ${props => props.theme.colors.stroke};
  cursor: pointer;
  box-sizing: border-box;
  line-height: 24px;
  &:after {
    content: '';
    display: inline-block;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid ${props => props.theme.colors.black};
    margin-left: 5px;
  }
  &.active {
    border: ${props => props.theme.borders.card};
    &:after {
      content: '';
      display: inline-block;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: none;
      border-bottom: 8px solid ${props => props.theme.colors.black};
      margin-left: 5px;
    }
  }
  
`;
const MenuWrapper = styled.div`
    position: absolute;
    width: 100%;
    top: 0px;
    padding-top: 55px;
    z-index: 9999;
    visibility: ${props => props.isActive ? 'display' : 'hidden'};
    background: ${props => props.theme.colors.white};
    box-shadow: ${props => props.theme.shadow.menu};
    border-top-left-radius: ${props => props.theme.borderRadius.round};
    border-top-right-radius: ${props => props.theme.borderRadius.round};
    ul {
      overflow: auto;
      max-height: 300px;
    }
    li {
        margin: 0px;
    }
`;

const MenuList = styled.ul`
    list-style-type: none;
    li {
        color: ${props => props.theme.colors.black};
        line-height: 24px;
        cursor: pointer;
        &:hover {
            background-color: ${props => props.theme.colors.lightBlue};
        }
        padding: 10px;
    }
`
const AddressDropDownMenu = ({ menu, handleClick }) => {
  const [showDropDownMenu, setShowDropDownMenu] = useState(false);

  const isMobile = useDeviceDetect();

  const getRichAddress = addr => {
    return `${addr.addressName}${addr.addressCompany?' - ' + addr.addressCompany:''} - ${addr.addressLine1}`
  }
  return (
    <Wrapper>
      <Button
        onClick={ () => isMobile && setShowDropDownMenu(!showDropDownMenu) }
        onMouseEnter={ () => !isMobile && setShowDropDownMenu(true) }
        onMouseLeave={ () => !isMobile && setShowDropDownMenu(false) }
        className={showDropDownMenu ? "active" : ""}
      >
        <label>Select address</label>
      </Button>
      <MenuWrapper 
        isActive = {showDropDownMenu}
        // onClick={ () => isMobile && setShowDropDownMenu(!showDropDownMenu) }
        onMouseEnter={ () => !isMobile && setShowDropDownMenu(true) }
        onMouseLeave={ () => !isMobile && setShowDropDownMenu(false) }
      >
        {menu && <MenuList>
          {menu.filter(menuItem => menuItem.addressName).map( (menuItem, i) => (
            <li
              key={ menuItem.id }
              onClick={() => {
                handleClick(menuItem);
                setShowDropDownMenu(false);
              }}
            >
              {getRichAddress(menuItem)}
              {/* <AddressCard data={menuItem}/> */}
            </li>
          ))}
        </MenuList>}
        </MenuWrapper>
    </Wrapper>
  )
}

export default AddressDropDownMenu;
